'use client'

import React from 'react'

import {
  RecipientAnalyticsSection,
  RecipientHeaderSection,
  RecipientRecentAwardsSection,
  RecipientStatsSection,
} from './RecipientSections'

export interface SuspenseRecipientViewProps {
  id: string
}

/**
 * Suspense-enabled Recipient View with granular sections.
 *
 * Each section has its own Suspense boundary, allowing:
 * - Independent loading states (partial page rendering)
 * - Independent error handling (one section can fail without affecting others)
 * - Better perceived performance (visible content loads first)
 */
export function SuspenseRecipientView({ id }: SuspenseRecipientViewProps) {
  return (
    <div className="flex min-h-full w-full flex-1 flex-col items-center bg-primary-50 pb-12 dark:bg-primary-950">
      <RecipientHeaderSection id={id} />
      <main className="mx-auto w-full max-w-7xl space-y-6 px-4 py-8 md:px-8">
        <RecipientStatsSection id={id} />
        <RecipientAnalyticsSection id={id} />
        <RecipientRecentAwardsSection id={id} />
      </main>
    </div>
  )
}
